module.exports = __webpack_public_path__ + "04d4f2ce3ffb442bd25fab650064c74c.png";